import { useSearchParams } from 'react-router-dom';

export function useAllForms() {
  const [searchParams] = useSearchParams();
  const allForms = searchParams.get('all');

  return !!allForms;
}
